import { FlexGrid, AppMenu, Box, spacing } from '@alinta-digital/asg';
import { ApolloClient, createHttpLink, InMemoryCache } from '@apollo/client';
import { setContext } from '@apollo/client/link/context';
import { v4 as uuidv4 } from 'uuid';
import * as React from 'react';
import { getToken } from '../utils';
import { getContactNumber, getQueryParams } from '../utils/utils';
import styled from 'styled-components';
import { StateType } from '../types';
import { Form } from './Form/Form';
import { AppFooter } from '../components/AppFooter';
import { useFeatureFlag } from '../utils/useFeatureFlag';
import InfoBanner from '../components/InfoBanner/InfoBanner';

const PageContent = styled.main`
  display: flex;
  flex: 1 0 auto;
  padding: ${spacing(16).medium};
`;

// Create a new instance of the Client using the BFF Url
export function createApolloClient(bffUrl: string): ApolloClient<any> {
  const httpLink = createHttpLink({
    uri: bffUrl,
    credentials: 'include',
  });

  // Sets the Context for the ApolloClient, this function will
  // be called everytime a request is made so getting the Auth Token
  // this way will allow it to always be up to date
  const authLink = setContext((_, { headers }) => {
    const token = getToken()?.accessToken;
    const xCorrelationId = uuidv4();

    return {
      headers: {
        ...headers,
        authorization: token ? `Bearer ${token}` : '',
        'x-correlation-id': xCorrelationId,
      },
    };
  });

  const client = new ApolloClient({
    link: authLink.concat(httpLink),
    cache: new InMemoryCache(),
    credentials: 'include',
  });

  return client;
}

// Direct Debit Functional Component
//
const DirectDebit: React.FC = () => {
  const queryParams = getQueryParams(window.location.search);
  const stateShortName = queryParams.state
    ? queryParams.state.toUpperCase()
    : 'VIC';

  const phone = getContactNumber(stateShortName as StateType);

  // const [getOktaTokenMutation] = useMutation(GET_OKTA_TOKEN, {
  //   onCompleted: (response) => {
  //     setToken(response.getOktaToken.data);

  //     // Set the Token timeout so that we refresh it if needed
  //     // The Token expiry is in seconds
  //     setTimeout(
  //       () =>
  //         getOktaTokenMutation({ variables: { input: config.digitalOkta } }),
  //       // Allow for time to get a new token...
  //       (response.getOktaToken.data.expiresIn + 1) * 1000
  //     );
  //   },
  //   onError: (error) => {
  //     console.error(error);
  //   },
  //   fetchPolicy: 'no-cache',
  // });

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  // const getTheTokenOnlyOnce = React.useEffect(() => {
  //   getOktaTokenMutation({ variables: { input: config.digitalOkta } });
  // }, []);
  const { data: paymentOutageData } = useFeatureFlag('MYA_PaymentOutage');
  const paymentOutage = paymentOutageData?.featureValue;
  return (
    <>
      <FlexGrid
        direction="column"
        wrap="nowrap"
        height="100vh"
        alignItems="stretch"
        margin="none"
      >
        <AppMenu
          phone={phone}
          logoSrc="https://www.alintaenergy.com.au/-/media/alinta-website/data/media/img/alinta_default_logo_brand_refresh.png"
        />
        {paymentOutage && (
          <InfoBanner
            backgroundColor="#196CFF"
            textColor="#FFFFFF"
            boderWidth="0px"
            style={{
              borderTopLeftRadius: '6px',
              borderBottomLeftRadius: '6px',
              color: '#FFFFFF',
            }}
          >
            <span
              style={{ fontWeight: 700, fontSize: '16px', color: '#FFFFFF' }}
            >
              We’re upgrading our payment features this weekend
            </span>
            <p
              style={{ fontWeight: 400, color: '#FFFFFF' }}
              dangerouslySetInnerHTML={{
                __html: `The form below is temporarily out of service. Please check back later.`,
              }}
            ></p>
          </InfoBanner>
        )}
        <PageContent>
          <Box maxWidth="1040px" width="100%" margin={{ horizontal: 'auto' }}>
            <Box margin={{ horizontal: 'small', top: 'xsmall' }}>
              <Form />
            </Box>
          </Box>
        </PageContent>
        <AppFooter phone={phone} />
      </FlexGrid>
    </>
  );
};

export default DirectDebit;
